import { SideMenu } from "../models/SideMenu";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import EmergencyRecordingIcon from "@mui/icons-material/EmergencyRecording";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import PolicyRoundedIcon from "@mui/icons-material/PolicyRounded";
import {
  HomeRounded,
  PeopleAltRounded,
  KeyRounded,
  ApartmentRounded,
  AccountBoxRounded,
  ConstructionRounded,
  CarRentalRounded,
  ReportProblemRounded,
  TaskRounded,
  EngineeringRounded,
  CalendarMonthRounded,
  Paid,
  Mail,
  FileOpenRounded,
  WarningAmberRounded,
  ScienceRounded,
  TableViewRounded,
  SettingsSuggestRounded,
  Business,
  BusinessRounded,
} from "@mui/icons-material";

export const ClientMenu: SideMenu[] = [
  {
    label: "Dashboard",
    icon: HomeRounded,
    link: "/client-dashboard",
    policy: "client-dashboard",
  },
  {
    label: "Action Plan For Compliance",
    icon: TaskRounded,
    link: "/task-view",
    policy: "client-task",
  },
  {
    label: "Company Profile",
    icon: BusinessRounded,
    link: "/profile",
    childMenu: [
      {
        label: "General Details",
        link: "/profile/general-details",
      },
      {
        label: "Registration Details",
        link: "/profile/registration-details",
      },
      {
        label: "Main Contact",
        link: "/profile/contact-details",
      },
      {
        label: "Company Documents",
        link: "/profile/company-documents",
      },
    ],
  },
  {
    label: "Staff",
    icon: PeopleAltRounded,
    link: "/staff",
    childMenu: [
      {
        label: "Employees",
        link: "/employee-table",
      },
      {
        label: "Sub Contractor",
        link: "/subcontractor-table",
      },
    ],
  },
  {
    label: "Plant & Equipment",
    icon: SettingsSuggestRounded,
    link: "plant-and-equipment",
    childMenu: [
      {
        label: "Equipment",
        link: "/equipment-table",
      },
      {
        label: "Vehicle",
        link: "/vehicle-table",
      },
      {
        label: "Chemical",
        link: "/chemical-table",
      },
      {
        label: "PPE",
        link: "/ppe-table",
      },
    ],
  },
  {
    label: "Settings & Setup",
    icon: AccountBoxRounded,
    link: "/settings-and-setup",
    childMenu: [
      {
        label: "Client Admin",
        link: "/client-admin",
        policy: "client-admin",
      },
      {
        label: "Documents",
        link: "/documents-table",
      },
    ],
  },
  {
    label: "Your Digital Safety Files",
    icon: ApartmentRounded,
    link: "/site-table",
    policy: "client-site",
  },
];
